import { Component, Input, OnDestroy } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { PaymentAnimationStates } from '../../../enums/payment-animation-states';
import { Subscription } from 'rxjs';
import { UnsubscribeHelper } from 'src/app/shared/helpers/unsubscribe.helper';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-payment-animated-states',
  templateUrl: './payment-animated-states.component.html',
  styleUrls: ['./payment-animated-states.component.scss'],
})
export class PaymentAnimatedStatesComponent implements OnDestroy {
  paymentAnimationStates = PaymentAnimationStates;
  private _state: PaymentAnimationStates = null;
  @Input() set state(value: PaymentAnimationStates) {
    this._state = value;

    if (
      value === this.paymentAnimationStates.success ||
      value === this.paymentAnimationStates.error
    ) {
      setTimeout(() => {
        this._state = null;
      }, 2000);
    }
  }
  get state(): PaymentAnimationStates {
    return this._state;
  }

  paymentInProgressOptions: AnimationOptions;
  paymentIsSuccessOptions: AnimationOptions;
  paymentIsErrorOptions: AnimationOptions;

  private readonly _subscriptions: Subscription[] = [];

  constructor(
    private _unsubscribeHelper: UnsubscribeHelper,

    private _http: HttpClient,
  ) {
    this._subscriptions.push(
      this._http
        .get<any>('./assets/animations/wait.json')
        .subscribe((value) => {
          this.paymentInProgressOptions = {
            animationData: value,
            loop: true,
          };
        }),
      this._http
        .get<any>('./assets/animations/success.json')
        .subscribe((value) => {
          this.paymentIsSuccessOptions = {
            animationData: value,
            loop: false,
          };
        }),
      this._http
        .get<any>('./assets/animations/decline.json')
        .subscribe((value) => {
          this.paymentIsErrorOptions = {
            animationData: value,
            loop: false,
          };
        }),
    );
  }

  public ngOnDestroy(): void {
    this._unsubscribeHelper.unsubscribe(this._subscriptions);
  }
}
